import React, { Component } from 'react';
import { connect } from 'react-redux';
// import moment from "moment";

class PriceFormatter extends Component {
    // constructor(props) {
    //     super(props);
    //     // console.log(moment.locale('en'))
    // }

    render() {


        const props = this.props;
        const { data,
            // type, date,
            price, setting } = props;
        // console.log('_________________________ price formater _________________________');
        // console.log(data);
        // console.log(type);
        // console.log("date");
        // console.log(date);
        // console.log("price");
        // console.log(price);
        // console.log(price.filter(item => (item.type === type)));
        // console.log(setting);
        let euro_price = parseFloat(setting.euro_price);
        // let mDate = moment(date,"YYYY-M-D");
        // let role = price.filter(item => (item.type === type) && moment(item.start_date, "YYYY-MM-DD").isBefore(date) && moment(item.end_date, "YYYY-MM-DD").isAfter(date))[0];
        let role = price;
        // console.log('role');
        // console.log(role);
        // console.log(price);
        let finalPrice = parseFloat(data) * (1 + parseFloat(role.increase_percent) / 100) / euro_price + parseFloat(role.increase_amount);
        if ((finalPrice <= 0) || (data === undefined)) {
            return (
                <span className={[props.className, 'light-grey-text'].join(' ')}>no Price</span>
            );
        }
        return (
            <span className={props.className}>
                {finalPrice.toFixed(2)}
                <small>€</small>
            </span>
        );
    }
}

function mapStateToProps(state) {
    return {
        price: state.price,
        setting: state.setting,
    }
}

export default connect(
    mapStateToProps,
)(PriceFormatter);



// WEBPACK FOOTER //
// ./src/components/misc/PriceFormatter.js